import { SubscriptionState } from "../contracts/SubscriptionState";
import { SubscriptionTier } from "../contracts/SubscriptionTier";

/** Days remaining at which the trial indicator turns from subtle into a banner. */
export const TRIAL_URGENT_THRESHOLD_DAYS = 14;

/**
 * UI-facing subscription status for the signed-in instructor (the instructor
 * paying us — pricing, never member billing). Flags are precomputed by the
 * mapper so components stay declarative.
 */
export interface SubscriptionStatus {
  state: SubscriptionState;
  trialStartedAt: Date;
  trialEndsAt: Date;
  trialDaysRemaining: number;
  complimentaryUntil: Date | null;
  isFoundingMember: boolean;
  tier: SubscriptionTier;
  hasProviderSubscription: boolean;
  /** The organization owner's subscription covers this instructor. */
  coveredByOrganization: boolean;
  organizationName: string | null;
  /** Admin price override — checkout charges this monthly amount instead of the list price. */
  customMonthlyAmountMinorUnits: number | null;
  /** Admin price override — checkout charges this annual amount instead of the list price. */
  customAnnualAmountMinorUnits: number | null;
  /** The currency of the custom price amounts ("USD" or "EUR"). Null without an override. */
  customPriceCurrency: string | null;
  /** ReadOnly or Cancelled — writes are rejected server-side. */
  isReadOnly: boolean;
  /** Trialing with no paid subscription yet — show the days-remaining indicator. */
  isTrialing: boolean;
  /** Trialing inside the final stretch — escalate the indicator to a banner. */
  isTrialUrgent: boolean;
}
